const Li_A = ({nameIco, linkIco}) => <li><a href={linkIco}><i className={nameIco} aria-hidden="true"></i></a></li>

const SecVerticalSocial = ({data}) => {

  return (
    <div className="vertical-social">
        <ul>
            {data && data.map((item , key) => (
                    <Li_A nameIco={item.nameIco} linkIco={item.linkIco} />
                ))
            }
            
        </ul>                  
    </div>
  );
}

export default SecVerticalSocial;